import React from "react";
import { connect } from "react-redux";
import { ModalsConsumer } from "../../Modal/ModalsProvider";
import SignInForm from "../../Form/SignInForm";
import couponManager from "../../../couponManager";

class Market extends React.Component {
  static defaultProps = {
    renderAnyway: false,
    marketId: null,
    selectedBets: []
  };

  shouldComponentUpdate() {
    return this.props.marketId !== null;
  }

  render() {
    if (this.props.outcome || this.props.renderAnyway) {
      let { outcomes, market, marketId, selectedBets, signedIn } = this.props;

      if (!signedIn) {
        return (
          <ModalsConsumer>
            {({ showModal }) => this.props.children({
              market,
              outcomes: Object.keys(outcomes).map(outcomeId => {
                const outcome = outcomes[outcomeId];

                return {
                  ...outcome,
                  selected: false,
                  addBet: showModal.bind(this, <SignInForm />),
                  removeBet: showModal.bind(this, <SignInForm />),
                  toggleBet: showModal.bind(this, <SignInForm />),
                };
              })
            })}
          </ModalsConsumer>
        );
      } else {
        return this.props.children({
          market,
          outcomes: Object.keys(outcomes).map(outcomeId => {
            const outcome = outcomes[outcomeId];

            return {
              ...outcome,
              selected: selectedBets.includes([marketId, outcomeId].join("@")),
              addBet: couponManager.addBet.bind(this, marketId, outcomeId),
              removeBet: couponManager.removeBet.bind(this, marketId, outcomeId),
              toggleBet: couponManager.toggleBet.bind(this, marketId, outcomeId),
            };
          }),
        });
      }
    } else {
      return null;
    }
  }
}


export default connect((state, ownProps) => {
  const market = state.markets.dict[ownProps.marketId];
  const outcomes = market ? market.bets : [];

  const markertInCoupon = state.coupon.bets.some(betId => {
    const betMarketId = +betId.split("@")[0];
    return ownProps.marketId === betMarketId;
  });

  const selectedBets = markertInCoupon ? state.coupon.bets : undefined;

  return {
    signedIn: !!state.user.profile,
    outcomes,
    market,
    selectedBets
  };
}, {})(Market);


// WEBPACK FOOTER //
// ./app/components/EsportsGame/Market/Market.jsx